module.exports = __webpack_public_path__ + "static/img/insta-depressed@2x.629f260.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/social-simulation/insta-depressed@2x.png
// module id = Rld1
// module chunks = 1